// Extract a structured location object from a Google Places Autocomplete
// `place` result. Returns null when coordinates are missing so callers can
// fall back to address-only writes without ever storing a half-populated
// location that fails the signup matcher's `typeof lat === 'number'` check.
export function extractLocation(place) {
  if (!place || !place.geometry || !place.geometry.location) return null;
  const lat = place.geometry.location.lat();
  const lng = place.geometry.location.lng();
  if (typeof lat !== 'number' || typeof lng !== 'number') return null;

  let city = '';
  let state = '';
  const components = place.address_components || [];
  for (const comp of components) {
    if (comp.types.includes('locality')) city = comp.long_name;
    // NYC boroughs don't fill `locality` — fall back to sublocality
    if (!city && comp.types.includes('sublocality_level_1')) city = comp.long_name;
    if (comp.types.includes('administrative_area_level_1')) state = comp.short_name;
  }

  return {
    address: place.formatted_address || '',
    lat,
    lng,
    city,
    state,
  };
}
